export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer une liste"])},
        "instruction": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pour créer une nouvelle liste, utilisez la recherche avancée pour définir vos critères, puis enregistrez votre sélection."])},
        "dont_show_popup_information": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ne plus afficher ce message"])},
        "go_to_advanced_search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accédez à la recherche avancée"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create a list"])},
        "instruction": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Use the advanced search to define your criteria, then save your selection."])},
        "dont_show_popup_information": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Don't show this message again"])},
        "go_to_advanced_search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go to advanced search"])}
      }
    }
  })
}
